
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { ReviewProductSource } from '@/Sources';
  import { IProductReviewType } from '@/Interfaces';
  import { isNullOrEmpty } from '../../utils';


  @Component({
    name: 'review-product-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class ReviewProductDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'Product' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    @Prop() public reviewId!: string | null;
    @Prop() public vendorId!: string | null;
    @Prop({ type: Boolean, default: false }) public inline!: boolean;
    @Prop({ default: '' }) public indent!: string;
    @Prop({ default: 'productId' }) public valueField!: keyof IProductReviewType;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public clearable!: boolean;

    public source: ReviewProductSource | IProductReviewType[] = [];
    public innerValue: IProductReviewType | null = null;

    public get val(): IProductReviewType | null { return this.innerValue; }
    public set val(value: IProductReviewType | null) {
      this.$emit('input', value === null ? '' : (value[this.valueField] ?? ''));
      this.$emit('review-product', value);
      this.innerValue = value;
    }

    @Watch('value', { immediate: true })
    public onValueChange(newValue: string) {
      if ((Array.isArray(this.source) && isNullOrEmpty(this.reviewId) && isNullOrEmpty(this.vendorId)) || (!Array.isArray(this.source) && this.source.isLoaded)) {
        const item = Array.isArray(this.source) ? this.source.find(x => x[this.valueField] === newValue) : this.source.items.find(x => x[this.valueField] === newValue);
        this.val = item ?? null;
      }
    }

    @Watch('reviewId', { immediate: true })
    public onReviewIdChange(newReviewId: string | null) {
      if (newReviewId !== null && this.vendorId !== null && newReviewId.length > 0 && this.vendorId.length > 0) {
        this.source = new ReviewProductSource(newReviewId, this.vendorId);
      } else if (!Array.isArray(this.source)) {
        this.source = [];
      }
    }

    @Watch('vendorId', { immediate: true })
    public onVendorIdChange(newVendorId: string | null) {
      if (this.reviewId !== null && newVendorId !== null && this.reviewId.length > 0 && newVendorId.length > 0) {
        this.source = new ReviewProductSource(this.reviewId, newVendorId);
      } else if (!Array.isArray(this.source)) {
        this.source = [];
      }
    }

    @Watch('source.cachedItems', { immediate: true })
    public onSourceItemsChange(newItems: IProductReviewType[]) {
      if (!Array.isArray(this.source) && this.source.isLoaded) {
        this.val = newItems.find(x => x[this.valueField] === this.value) ?? null;
        this.$emit('items', newItems);
      }
    }

    @Watch('source', { immediate: true })
    public onSourceChange(newSource: ReviewProductSource | IProductReviewType[]) {
      this.$emit('source', newSource);
      if (Array.isArray(newSource)) {
        this.val = newSource.find(x => x[this.valueField] === this.value) ?? null;
        this.$emit('items', newSource);
      }
    }
  }
